import React from "react"
import PropTypes from "prop-types"
import "./navbar.css"
// import Routes from "../Routes"
// import AnchorLink from "react-anchor-link-smooth-scroll"
import Link from "gatsby-link"
// import Enquiry from "../../components/enquiry"
import BusinessEnquiryForm from "../BusinessEnquiryForm"
import $ from "jquery"
// import { DropdownButton, MenuItem, ButtonToolbar } from "react-bootstrap"
// const Logo = "http://alpexonline.com/assets/images/LOGO.png"

export class NavBar extends React.Component {
	constructor (args) {
		super(args)
		this.state = {
			activeNav: "",
			prevScrollpos: window.pageYOffset,
			routeUrl: "/",
			isNavChange: true,
			visible: true,
			isModalOpen : false,
			activeNav: this.props.route
		}
	}
	onBusinessSub = () => {
		this.setState({
			isModalOpen: !this.state.isModalOpen
		})
	}
	handleScroll = (event) => {
		// // console.log("Scroolsadsadsd", event)
		const { prevScrollpos } = this.state
		let currentScrollPos = window.scrollY
		// let itemTranslate = Math.min(0, currentScrollPos / 3)
		const visible = currentScrollPos === 0 && (currentScrollPos - 1 < (prevScrollpos))
		this.setState({
			prevScrollpos: currentScrollPos,
			visible
		})
	}
	componentWillUnmount () {
		window.removeEventListener("scroll", this.handleScroll, true)
	}
	componentDidMount = () => {
		$(document).ready(function () {
			$(".act").click(function () {
				$(".act").removeClass("active")
				$(".act").addClass("active")
				$(".act").removeClass("active")
				$(this).addClass("active")
			})
		})

		// window.addEventListener("scroll", this.handleScroll, true)
		// this.setState({
		// 	// isNavChange: false,
		// 	routeUrl: window.location.pathname,
		// })
		// setTimeout(() => {
		// 	this.setState({
		// 	})
		// }, 1000)
		// console.log(window.location)
	}
	handleActiveNav = (identifier) => {
		const { getActiveRoute } = this.props
		// getActiveRoute(identifier)
		// this.setState({
		// })
		this.setState({
			// isNavChange: false,
			routeUrl: "/",
		})
		// setTimeout(() => {
		// 	this.setState({
		// 		isNavChange: true,
		// 	})
		// }, 0)
	}
	render () {
		const { activeNav, routeUrl, isNavChange, visible, isModalOpen, } = this.state
		let activeUrl = routeUrl === "/" || routeUrl === "/home"
		const { route } = this.props
		// let activeNav = route
		// let isDiffNavBar = (this.diffNavBar.indexOf(route) >= 0)
		return (<div id="navBar" className={`nav__bar ${!visible ? "ease" : ""}`}>
			<div className="logo"><div className=""><a href="/home" className=""><img src="https://www.jayceepower.com/images/newImages/JC_updated_logo.png" alt="Jaycee logo" /></a></div></div>
			<div className="right__to__logo">
				<span className="dropdown">
					<div className=""><Link to="/home#about" className="act">About</Link></div>
					<div className="dropdown-content">
						<div className=""><Link className="" to="/team" ><div className="t_n"><span>Team</span></div></Link></div>
						<div className=""><Link className="" to="/awards" ><div className="t_n"><span>Awards</span></div></Link></div>
						<div className=""><Link className="" to="/infrastructure" ><div className="t_n"><span>infrastructure</span></div></Link></div>
					</div>
				</span>
				<span className="dropdown">
					<div className=""><Link to="/home#whyjaycee" className="act">why jaycee</Link></div>
				</span>
				<span className="dropdown">
					<Link to="/home/#clients" className="act">clients</Link>
				</span>
				<span className="dropdown">
					<Link to="/home/#products" className="act">products</Link>
					<div className="dropdown-content">
						<div className=""><Link className="" to="/dieselGenerators" ><div className="t_n"><span>Diesel Generators</span></div></Link></div>
						{/*<div className=""><Link className="" to="/portablegenerators" ><div className="t_n"><span>Portable Generators</span></div></Link></div> */}
						<div className=""><Link className="" to="/electricalstampings" ><div className="t_n"><span>Electrical Stampings</span></div></Link></div>
					</div>
				</span>
				<span className="dropdown">
					<div className=""><Link to="/projects" className="act">Projects</Link></div>
				</span>
				<span className="dropdown">
					<div className=""><Link to="/connect" className="act">Connect</Link></div>
					<div className="dropdown-content">
						<div className=""><Link className="" to="/locateadealer" ><div className="t_n"><span>Locate a Dealer</span></div></Link></div>
					</div>
				</span>
			</div>
			<div className="desTop">
				<div className="subRight" onClick={this.onBusinessSub}>
					<span>Quick Enquiry</span>
				</div>
			</div>
			<BusinessEnquiryForm show={isModalOpen} onHide={this.onBusinessSub} />
		</div>
		)
	}
}

NavBar.propTypes = {
	getActiveRoute: PropTypes.func
}

export default NavBar



// WEBPACK FOOTER //
// ./src/components/TopNavigationBar/NavBar.js